// Which formats a report may be exported as, and what to call them.
//
// The admin sets the list and the default on the report's settings screen;
// this only renders what the server sent. Shared by the single-item export
// and the batch export so the two cannot drift: a report offered as Excel
// and PDF on one surface must offer both on the other.

export const FORMAT_LABELS = { xlsx: 'Excel', docx: 'Word', pdf: 'PDF' };

export function outputsFor(report) {
  const formats = Array.isArray(report.output_formats) && report.output_formats.length
    ? report.output_formats
    : [report.native_format].filter(Boolean);
  const preferred = report.default_output_format;
  const ordered = preferred && formats.includes(preferred)
    ? [preferred, ...formats.filter(f => f !== preferred)]
    : formats;
  return ordered.map(fmt => ({ fmt, label: FORMAT_LABELS[fmt] || String(fmt).toUpperCase() }));
}
